import { ScholarshipDetails } from '@components/scholarship-details/scholarship-details';

export const ScholarshipDetailsWidget = () => <ScholarshipDetails />;
